<div [class.hidden]="!show">
	<div *ngIf="show" class="loading">Loading&#8230;</div>
</div>